'use strict';

const MicroModal = require('../vendors/micromodal.min');

function decodeEntities(value) {
    if (!value) return value;
    if (typeof document === 'undefined') {
        return String(value).replace(/&quot;/g, '"').replace(/&#0?39;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
    }
    const decoder = document.createElement('textarea');
    decoder.innerHTML = value;
    return decoder.value;
}

const escapeHTML = value => String(value).replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
const numberFormatter = new Intl.NumberFormat('de-DE');
const formatDate = value => value.split('-').reverse().join('.');
function reviewFromItem(item) {
  return {id: Number(item.id), stars: Number(item.rating), date: item.date,
    recommendation: item.recommendation ?? null,
    author: decodeEntities(item.fullName), text: decodeEntities(item.text), reply: decodeEntities(item.comment)};
}

function createReviewState() {
  return {stars: [], topic: '', query: '', order: 'newest', page: 1};
}

function transitionReviewState(state, action, value) {
  switch (action) {
    case 'search': return {...state, query: String(value), page: 1};
    case 'sort': return {...state, order: value, page: 1};
    case 'rating': return {...state, stars: value ? [value] : [], page: 1};
    case 'topic': return {...state, topic: state.topic === value ? '' : value, page: 1};
    case 'load-more': return {...state, page: state.page + 1};
    case 'critical': return {...createReviewState(), stars: [1, 2, 3]};
    case 'reset': return createReviewState();
    default: throw new Error(`Unknown review action: ${action}`);
  }
}

function starsMarkup(value) {
  return `<span class="stars" role="img" aria-label="${value} von 5 Sternen">${Array.from({length:5}, (_,i) => `<svg aria-hidden="true" viewBox="0 0 16 16"${i < value ? '' : ' class="unfilled"'}><use href="#product-reviews-star"></use></svg>`).join('')}</span>`;
}

function renderReviewMarkup(review) {
  const text = review.text || 'Bewertung ohne Text.';
  const fullText = escapeHTML(text);
  const body = `<p class="entry-text${review.text ? '' : ' muted'}">${fullText}</p>`;
  return `<article class="review-entry" data-review-id="${review.id}" tabindex="-1" aria-label="Bewertung von ${escapeHTML(review.author)}, ${review.stars} von 5 Sternen">
    <div class="entry-meta"><span class="entry-name">${escapeHTML(review.author)}</span></div>
    <div class="entry-main"><div class="entry-top">${starsMarkup(review.stars)}<time datetime="${review.date}">${formatDate(review.date)}</time></div>
    ${renderRecommendationMarkup(review.recommendation)}
    ${body}
    ${renderReplyMarkup(review.reply)}</div>
  </article>`;
}

function renderReplyMarkup(reply) {
  return reply ? `<div class="entry-reply"><strong>Antwort von Follower24</strong><p>${escapeHTML(reply)}</p></div>` : '';
}

function renderRecommendationMarkup(recommendation) {
  if (recommendation !== true && recommendation !== false) return '';
  return `<span class="entry-recommendation${recommendation ? ' entry-recommendation--positive' : ''}">
    ${recommendation ? '<svg aria-hidden="true" focusable="false" viewBox="0 0 25 25" fill="none"><use href="#experience-recommendation-thumb"></use></svg>' : ''}
    <span>${recommendation ? 'Empfiehlt Follower24 weiter' : 'Keine Weiterempfehlung'}</span></span>`;
}

if (typeof document !== 'undefined') {
const ratingUrl = document.querySelector('#page-content').dataset.ratingUrl;
async function requestReviews(params) {
  const response = await fetch(`${ratingUrl}?${new URLSearchParams(params)}`);
  if (!response.ok) throw new Error('Reviews could not be loaded.');
  return response.json();
}
let state = createReviewState();
const search = document.querySelector('#review-search');
const searchPanel = document.querySelector('.review-search-panel');
const sorting = document.querySelector('#review-sort');
const list = document.querySelector('#review-list');
const filterPanel = document.querySelector('.review-filter-panel');
const mobileFilters = matchMedia('(max-width: 700px)');
function adaptFilters() { filterPanel.open = !mobileFilters.matches; }
mobileFilters.addEventListener('change', adaptFilters);
adaptFilters();

// The legacy CSS build cannot parse @container. Keep the mockup's card-width breakpoint.
new ResizeObserver(([entry]) => {
  entry.target.toggleAttribute('data-wide', entry.contentRect.width > 360);
}).observe(document.querySelector('.rating-overview'));

// MicroModal's tab sequence excludes the initially focused static heading.
document.querySelector('#review-modal-title').addEventListener('keydown', event => {
  if (event.key === 'Tab' && event.shiftKey) {
    event.preventDefault();
    document.querySelector('#review-modal .modal__btn').focus();
  }
});

let sourceRequest = 0;
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-review-source], [data-review-info]');
  if (!trigger) return;
  const modalId = 'review-modal';
  const title = document.querySelector(`#${modalId} .modal__title`);
  const content = document.querySelector('#review-modal-content');
  const request = ++sourceRequest;
  if (trigger.hasAttribute('data-review-info')) {
    title.textContent = 'Woher kommen diese Bewertungen?';
    content.replaceChildren(document.querySelector('#review-source-info').content.cloneNode(true));
  } else if (trigger.hasAttribute('data-review-source')) {
    title.textContent = 'Bewertung auf ProvenExpert';
    content.textContent = 'Bewertung wird geladen …';
    requestReviews({id: trigger.dataset.reviewSource}).then(data => {
      if (request !== sourceRequest) return;
      if (!data.items.length) { content.textContent = 'Diese Bewertung ist derzeit nicht verfügbar.'; return; }
      const review = reviewFromItem(data.items[0]);
      content.innerHTML = `<div class="modal-review-meta"><strong>${escapeHTML(review.author)}</strong><time datetime="${review.date}">${formatDate(review.date)}</time></div>
      ${starsMarkup(review.stars)}${renderRecommendationMarkup(review.recommendation)}<p class="modal-review-text">${escapeHTML(review.text || 'Bewertung ohne Text.')}</p>
      ${renderReplyMarkup(review.reply)}<div class="modal-review-source"><img src="${document.querySelector('#page-content').dataset.provenLogo}" alt="ProvenExpert" width="120" height="28"><a href="https://www.provenexpert.com/de-de/follower24/" target="_blank" rel="noopener noreferrer">Bewertungsprofil auf ProvenExpert öffnen<span class="sr-only"> (neuer Tab)</span></a></div>`;
    }).catch(() => { if (request === sourceRequest) content.textContent = 'Die Bewertung konnte nicht geladen werden. Bitte öffne die Quelle erneut.'; });
  }
  const background = [];
  MicroModal.show(modalId, {
    closeTrigger: 'data-modal-close', disableScroll: true,
    awaitCloseAnimation: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    onShow: modal => {
      // Include the shared layout without making an ancestor of the dialog inert.
      for (let branch = modal; branch !== document.body; branch = branch.parentElement) {
        for (const sibling of branch.parentElement.children) {
          if (sibling === branch || sibling.inert) continue;
          sibling.inert = true;
          background.push(sibling);
        }
      }
      modal.querySelector('.modal__container').scrollTop = 0;
      title.focus({preventScroll:true});
    },
    onClose: () => {
      sourceRequest++;
      background.forEach(element => { element.inert = false; });
      trigger.focus({preventScroll:true});
    }
  });
});

function renderSummary(data) {
  const rating = Number(data.rating).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  document.querySelector('.rating-score strong').textContent = rating;
  document.querySelector('.rating-score .stars').setAttribute('aria-label', `${rating} von 5 Sternen`);
  document.querySelectorAll('.rating-score svg').forEach((star, i) => star.classList.toggle('unfilled', i >= Math.round(Number(data.rating))));
  document.querySelector('.rating-caption').textContent = `${data.reviewsFormattedNum} Bewertungen`;
  document.querySelector('.rating-approval strong').textContent = data.approvalRate;
  const updated = data.latestDate ? `Neueste Bewertung: ${data.latestDate}` : 'Noch keine Bewertungen';
  document.querySelectorAll('[data-review-updated]').forEach(element => { element.textContent = updated; });
  document.querySelector('#review-source-info').content.querySelector('[data-review-updated]').textContent = updated;
  const total = Object.values(data.ratings).reduce((sum, count) => sum + Number(count), 0);
  document.querySelectorAll('[data-stars]').forEach(button => {
    const stars = Number(button.dataset.stars);
    const count = stars ? Number(data.ratings[stars] || 0) : total;
    button.querySelector('.star-count').textContent = numberFormatter.format(count);
    button.setAttribute('aria-label', `${stars ? `${stars} ${stars === 1 ? 'Stern' : 'Sterne'}` : 'Alle Sterne'}, ${numberFormatter.format(count)} Bewertungen`);
    if (stars) button.querySelector('.filter-bar span').style.width = `${total ? count / total * 100 : 0}%`;
  });
}

let reviewRequest = 0;
let searchTimer;
let retryAppend = false;
async function renderReviews(append = false) {
  const request = ++reviewRequest;
  const next = append ? transitionReviewState(state, 'load-more') : state;
  const previousCount = list.children.length;
  const loadMore = document.querySelector('#load-reviews');
  retryAppend = append;
  loadMore.disabled = true;
  list.setAttribute('aria-busy', 'true');
  document.querySelector('#review-error').hidden = true;
  document.querySelector('#empty-state').hidden = true;
  document.querySelector('#result-count').textContent = 'Bewertungen werden geladen …';
  try {
    const data = await requestReviews({page: next.page, search: next.query, ratingValue: next.stars.join(','), topic: next.topic, sort: next.order});
    if (request !== reviewRequest) return;
    const markup = data.items.map(reviewFromItem).map(renderReviewMarkup).join('');
    if (append) list.insertAdjacentHTML('beforeend', markup);
    else list.innerHTML = markup;
    state = next;
    renderSummary(data);
    document.querySelector('#result-count').textContent = `${numberFormatter.format(data.totalCount)} ${data.totalCount === 1 ? 'Bewertung' : 'Bewertungen'}${state.query.trim() || state.topic || state.stars.length ? ' gefunden' : ''}`;
    document.querySelector('#shown-count').textContent = `${numberFormatter.format(list.children.length)} von ${numberFormatter.format(data.totalCount)} Bewertungen gesehen`;
    document.querySelector('#empty-state').hidden = data.totalCount > 0;
    document.querySelector('#results-bottom').hidden = data.totalCount === 0;
    loadMore.hidden = state.page >= data.pagesNum;
    if (append) list.children[previousCount]?.focus({preventScroll:true});
  } catch (error) {
    if (request !== reviewRequest) return;
    document.querySelector('#result-count').textContent = 'Bewertungen konnten nicht geladen werden.';
    document.querySelector('#review-error').hidden = false;
  } finally {
    if (request === reviewRequest) {
      list.setAttribute('aria-busy', 'false');
      loadMore.disabled = false;
    }
  }
}
function renderFilters() {
  document.querySelector('#clear-search').hidden = !state.query;
  const active = [state.query.trim() && `Suche: „${state.query.trim()}“`, state.stars.length && `${state.stars.join(', ')} ${state.stars.length === 1 && state.stars[0] === 1 ? 'Stern' : 'Sterne'}`, state.topic && document.querySelector(`[data-topic="${state.topic}"]`).textContent].filter(Boolean);
  document.querySelector('#review-filter-summary').textContent = active.length ? `${active.length} Filter aktiv` : 'Alle Bewertungen';
  document.querySelector('#active-filters').textContent = active.join(' · ');
  document.querySelector('#active-filters').hidden = !active.length;
  document.querySelector('#reset-filters').hidden = !active.length && state.order === 'newest';
  document.querySelectorAll('[data-stars]').forEach(button => button.setAttribute('aria-pressed', Number(button.dataset.stars) === 0 ? !state.stars.length : state.stars.includes(Number(button.dataset.stars))));
  document.querySelectorAll('[data-topic]').forEach(button => button.setAttribute('aria-pressed', button.dataset.topic === state.topic));
}
function syncReviewControls() { search.value = state.query; sorting.value = state.order; }
function resetPagination(action, value) {
  clearTimeout(searchTimer);
  reviewRequest++;
  state = transitionReviewState(state, action, value);
  renderFilters();
  list.replaceChildren();
  document.querySelector('#results-bottom').hidden = true;
  document.querySelector('#empty-state').hidden = true;
  document.querySelector('#review-error').hidden = true;
  document.querySelector('#result-count').textContent = 'Bewertungen werden geladen …';
  list.setAttribute('aria-busy', 'true');
  if (action === 'search') searchTimer = setTimeout(() => renderReviews(), 250);
  else renderReviews();
}
search.addEventListener('input', () => resetPagination('search', search.value));
sorting.addEventListener('change', () => resetPagination('sort', sorting.value));
document.querySelector('#clear-search').addEventListener('click', () => { resetPagination('search', ''); syncReviewControls(); search.focus(); });
document.querySelectorAll('[data-stars]').forEach(button => button.addEventListener('click', () => resetPagination('rating', Number(button.dataset.stars))));
document.querySelectorAll('[data-topic]').forEach(button => button.addEventListener('click', () => resetPagination('topic', button.dataset.topic)));
document.querySelectorAll('[data-reset-filters]').forEach(button => button.addEventListener('click', () => {
  resetPagination('reset');
  syncReviewControls();
  const focusTarget = !filterPanel.open ? filterPanel.querySelector('summary') : searchPanel.open ? search : searchPanel.querySelector('summary');
  focusTarget.focus({preventScroll: true});
}));
document.querySelector('#load-reviews').addEventListener('click', () => renderReviews(true));
document.querySelector('#retry-reviews').addEventListener('click', () => renderReviews(retryAppend));
document.querySelectorAll('[data-critical-link]').forEach(link => link.addEventListener('click', () => { resetPagination('critical'); syncReviewControls(); sorting.focus({preventScroll:true}); }));
syncReviewControls();
renderFilters();
renderReviews();

const pageNav = document.querySelector('.page-nav');
const sectionStrip = pageNav.querySelector('.page-nav-links');
function updateNavOverflow() {
  pageNav.toggleAttribute('data-more-sections', sectionStrip.scrollWidth - sectionStrip.clientWidth - sectionStrip.scrollLeft > 1);
}
sectionStrip.addEventListener('scroll', updateNavOverflow, {passive:true});
new ResizeObserver(updateNavOverflow).observe(sectionStrip);
updateNavOverflow();
const sectionLinks = [...pageNav.querySelectorAll('a')];
const sections = sectionLinks.map(link => document.querySelector(link.hash));
let currentSection = '';
let navigationTarget = '';
function markSection(current) {
  if (current === currentSection) return;
  currentSection = current;
  sectionLinks.forEach(link => {
    if (link.hash === `#${current}`) link.setAttribute('aria-current', 'location');
    else link.removeAttribute('aria-current');
  });
  const activeLink = pageNav.querySelector('[aria-current]');
  const strip = activeLink.parentElement;
  const linkBox = activeLink.getBoundingClientRect();
  const stripBox = strip.getBoundingClientRect();
  if (linkBox.left < stripBox.left) strip.scrollLeft += linkBox.left - stripBox.left;
  else if (linkBox.right > stripBox.right) strip.scrollLeft += linkBox.right - stripBox.right;
}
function updateSectionNav() {
  if (navigationTarget) return;
  const offset = parseFloat(getComputedStyle(sections[0]).scrollMarginTop) + 1;
  const current = sections.findLast(section => section.getBoundingClientRect().top <= offset)?.id || sections[0].id;
  markSection(current);
}
function trackAnchor(hash) {
  navigationTarget = sections.find(section => `#${section.id}` === hash)?.id || '';
  if (navigationTarget) markSection(navigationTarget);
}
document.querySelectorAll('.experiences-page a[href^="#"]').forEach(link => link.addEventListener('click', event => {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  trackAnchor(link.hash);
}));
// The shared legacy bundle reloads on popstate. Keep this static page's native
// fragment navigation and history in-document so review filters survive.
addEventListener('popstate', event => {
  event.stopImmediatePropagation();
  trackAnchor(location.hash);
}, {capture: true});
function resumeSectionTracking() { navigationTarget = ''; updateSectionNav(); }
addEventListener('scrollend', event => {
  if (event.target !== document) return;
  const target = document.getElementById(navigationTarget);
  // The normal header can appear/disappear during the native anchor scroll.
  // A correction can reveal the header again; keep the target until it settles.
  if (target) {
    const correction = target.getBoundingClientRect().top - parseFloat(getComputedStyle(target).scrollMarginTop);
    if (Math.abs(correction) > 1) {
      scrollBy({top: correction, behavior: 'instant'});
      return;
    }
  }
  navigationTarget = '';
  updateSectionNav();
});
addEventListener('wheel', resumeSectionTracking, {passive:true});
addEventListener('touchstart', resumeSectionTracking, {passive:true});
addEventListener('keydown', event => {
  if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) resumeSectionTracking();
});
addEventListener('scroll', updateSectionNav, {passive:true});
addEventListener('resize', resumeSectionTracking);
updateSectionNav();


}

module.exports = {createReviewState, decodeEntities, escapeHTML, renderReplyMarkup, renderReviewMarkup, reviewFromItem, transitionReviewState};
